import {
  H2_TEAM_IMG01,
  H2_TEAM_IMG02,
  H2_TEAM_IMG03,
  H2_TEAM_IMG04,
} from "../lib/assets";

/** Structural team data (locale-free). Copy lives in locales/{locale}/team.json */
export const TEAM_STRUCTURE = [
  {
    id: 1,
    href: "/team-details",
    src: H2_TEAM_IMG01,
    title: "Miller Chavarro",
  },
  {
    id: 2,
    href: "/team-details",
    src: H2_TEAM_IMG02,
    title: "Antonio Hernández",
  },
  {
    id: 3,
    href: "/team-details",
    src: H2_TEAM_IMG03,
    title: "Andrés Cruz",
  },
  {
    id: 4,
    href: "/team-details",
    src: H2_TEAM_IMG04,
    title: "Nayury Soto",
  },
];

export const getTeam = (t) =>
  TEAM_STRUCTURE.map((member) => {
    const copy = t(String(member.id), { ns: "team", returnObjects: true });
    return {
      ...member,
      ...(copy && typeof copy === "object" ? copy : {}),
    };
  });

/** @deprecated Prefer getTeam(t) */
export const TEAM_LIST = TEAM_STRUCTURE;
